import PropTypes from 'prop-types';

import CustomIcon from '../../CustomIcons';
import NavLoader from './NavLoader';

function DesktopNavigations({ navItems, isLoader, pathname, loaderNavLabel, setHostName, parentNav, childClass }) {
  return (
    <ul className={`flex-group ${childClass}`}>
      {parentNav && (
        <h3 className="global-nav__parent-tab">
          <span className="parent-tab">{parentNav}</span>
        </h3>
      )}
      {navItems.map(item => {
        const {
          link,
          link: { href: rawHref },
          items = []
        } = item;
        const isActiveTab = pathname.toLowerCase().includes(rawHref.toLowerCase());
        const { title, iconClass, target, href } = setHostName({ link });
        return (
          <li className={`flex-group global-nav__item ${isActiveTab ? 'active-tab' : ''}`} key={title}>
            <a className="flex-group" target={target} href={href}>
              <span>
                {!!iconClass && (
                  <i>
                    <CustomIcon size="20" type={iconClass} className={iconClass} fill="#FFF" />
                  </i>
                )}
                {title}
              </span>
              {!!items.length && <CustomIcon size="20" type="fwdArrow" className="right-arrow" fill="#FFF" />}
            </a>
            {/* 'scroll': This class got added to achieve the scroll bar when there are more items (childrens)
            coming in from API response. This is temporary solution as of now becasue of the very limited
            option with the current design of global nav menu */}
            {!!items.length && (
              <DesktopNavigations
                navItems={items}
                childClass={`child-menu ${items.length >= 8 ? 'scroll' : ''}`}
                pathname={pathname}
                loaderNavLabel={loaderNavLabel}
                setHostName={setHostName}
                parentNav={title}
                isLoader={'isProductsLoader' in item}
              />
            )}
          </li>
        );
      })}
      {isLoader && <NavLoader text={loaderNavLabel} />}
    </ul>
  );
}

DesktopNavigations.propTypes = {
  navItems: PropTypes.instanceOf(Array).isRequired,
  setHostName: PropTypes.func.isRequired,
  loaderNavLabel: PropTypes.string.isRequired,
  pathname: PropTypes.string,
  parentNav: PropTypes.string,
  childClass: PropTypes.string,
  isLoader: PropTypes.bool
};

DesktopNavigations.defaultProps = {
  pathname: '',
  parentNav: '',
  childClass: '',
  isLoader: false
};

export default DesktopNavigations;
